module.exports = __webpack_public_path__ + "02_bob_yellow.ef9a6d46.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_bob_yellow.png
// module id = mfNi
// module chunks = 0